<h1>{{ ("organisation" | i18n) || "Organisations" }}</h1>
<div
  class="organisations"
  *ngIf="customer$ | async as customer">
  <div class="row filter-bar">
    <div class="col-md-12">
      <app-text-search
        class="filter-bar"
        [useQueryParam]="'search'"
        (searchTextChanged)="searchFromInput($event)">
      </app-text-search>
    </div>
  </div>
  <div
    class="organisation-list"
    data-cy="organisations-list">
    <ng-container *ngIf="!(organisationsLoading$ | async); else loading">
      <mat-card
        *ngFor="let organisation of organisations$ | async; trackBy: trackById"
        class="organisation-list-card"
        [attr.data-cy]="'organisation-list-item-id-' + organisation._id">
        <mat-card-title>
          <div data-cy="organisation-name">{{ organisation.name }}</div>
          <div *ngIf="customer?.timeTrackingEnabled">
            {{ ("timeTracking" | i18n) || "Zeiterfassung" | titlecase }}
          </div>
        </mat-card-title>
        <mat-card-content class="organisation-main-body">
          <div
            *ngIf="
              organisation.address &&
              (organisation.address.street ||
                organisation.address.zip ||
                organisation.address.location)
            "
            class="organisation-address"
            data-cy="organisation-address">
            <span *ngIf="organisation.address.street">
              {{ organisation.address.street }}, </span
            ><span *ngIf="organisation.address.zip">
              {{ organisation.address.zip }} </span
            ><span *ngIf="organisation.address.location">
              {{ organisation.address.location }}
            </span>
          </div>
          <div class="organisation-level-options">
            <app-tag-select
              *ngIf="customer?.enableTags"
              data-cy="organisation-tags"
              [selectedTags]="organisation.customerInformation?.[customer!._id!]?.tags || []"
              (tagAdded)="selectTag(organisation, customer, $event)"
              (tagRemoved)="removeTag(organisation, customer, $event)"
              (addNewlyCreatedTag)="
                addTagToLocalOrg(organisation, customer, $event)
              "
              (tagCreated)="newTagAdded(organisation._id, customer, $event)">
            </app-tag-select>
            <div
              *ngIf="customer?.timeTrackingEnabled"
              class="organisation-time-tracking"
              [matTooltip]="
                organisation.timeTrackingEnabledByOwner
                  ? ('timeTrackingEnabledByOwnerTooltip' | i18n)
                  : ''
              ">
              <mat-checkbox
                [(ngModel)]="organisation.timeTrackingEnabled"
                name="selectAllDepartments"
                [disabled]="organisation.timeTrackingEnabledByOwner ?? false"
                (click)="
                  toggleTimeTrackingOnOrganisation(
                    $event,
                    organisation,
                    customer,
                    disableTimeTrackingConfirm
                  )
                ">
              </mat-checkbox>
            </div>
          </div>
          <div class="organisation-departments-list">
            <app-accordion
              *ngFor="
                let department of organisation.departments;
                trackBy: trackByDepartmentId
              "
              [collapsed]="department.collapsed"
              class="organisation-department">
              <app-accordion-header
                [collapseOnHeaderClick]="true"
                [displayArrowButton]="true"
                [newCollapseButton]="false"
                class="organisation-department-name">
                <span>
                  {{ department.name }}
                </span>
              </app-accordion-header>
              <app-accordion-content
                #accordionContent
                class="organisation-department-options">
                <ng-container
                  *ngIf="!(accordionContent.contentCompletelyHidden$ | async)">
                  <div *ngIf="customer?.autoBookInvitees">
                    <mat-slide-toggle
                      [ngModel]="
                    department.customerInformation?.[customer._id!]?.autoBookInvitees !== undefined ?
                      department.customerInformation?.[customer._id!]?.autoBookInvitees
                      : customer.autoBookInviteesDepartmentDefault || false"
                      (ngModelChange)="
                        updateDepartmentAutoBookInvitees(
                          department,
                          customer._id
                        )
                      "
                      name="autoBookInvitees"
                      data-cy="customer-flags-enable-demand-reasons">
                      {{ ("autoBookInvitees" | i18n) || "Auto Book Invitees " }}
                    </mat-slide-toggle>
                  </div>
                  <div *ngIf="customer?.autoBookSelfSignIns">
                    <mat-slide-toggle
                      [ngModel]="
                    department.customerInformation?.[customer!._id]?.autoBookSelfSignIns !== undefined ?
                      department.customerInformation?.[customer!._id]?.autoBookSelfSignIns
                      : customer.autoBookSelfSignInsDepartmentDefault || false
                  "
                      (ngModelChange)="
                        updateDepartmentAutoBookSelfSignIns(
                          department,
                          customer
                        )
                      "
                      [disabled]="!department.customerInformation?.[customer!._id]?.autoBookInvitees && !customer.autoBookInviteesDepartmentDefault"
                      name="autoBookSelfSignIns"
                      data-cy="customer-flags-enable-demand-reasons">
                      {{
                        ("autoBookSelfSignIns" | i18n) ||
                          "Auto Book Self Sign Ins "
                      }}
                    </mat-slide-toggle>
                  </div>
                  <div
                    class="prevent-direct-accept-within-seconds-per-shift-settings">
                    <h3>
                      {{
                        ("preventDirectAcceptWithinHoursPerShift" | i18n) ||
                          "Direkte Buchungseinstellungen"
                      }}
                    </h3>
                    <div class="shift-settings-container row">
                      <div class="col-md-3">
                        <mat-form-field>
                          <mat-label>{{
                            ("shifts.0" | i18n) || "Früh"
                          }}</mat-label>
                          <input
                            matInput
                            type="number"
                            [ngModel]="
                              department.appliedValues[shiftEnum.EARLY]
                            "
                            (ngModelChange)="
                              updateDepartmentPreventDirectAcceptWithinSecondsPerShift(
                                department,
                                customer._id,
                                shiftEnum.EARLY,
                                $event
                              )
                            "
                            name="preventDirectAcceptWithinSecondsPerShiftEarly"
                            data-cy="prevent-direct-accept-within-seconds-per-shift-early-shift" />
                          <button
                            *ngIf="
                              department.appliedValues[shiftEnum.EARLY] !==
                              department.defaultValues[shiftEnum.EARLY]
                            "
                            mat-icon-button
                            matSuffix
                            type="button"
                            (click)="
                              resetDepartmentPreventDirectAcceptValue(
                                department,
                                customer._id,
                                shiftEnum.EARLY
                              )
                            "
                            data-cy="reset-prevent-direct-accept-early-shift">
                            <mat-icon svgIcon="close"></mat-icon>
                          </button>
                          <mat-hint
                            *ngIf="
                              department.appliedValues[shiftEnum.EARLY] !==
                              department.defaultValues[shiftEnum.EARLY]
                            ">
                            {{ "default" | i18n }}:
                            <span style="text-decoration: line-through">
                              {{ department.defaultValues[shiftEnum.EARLY] }}h
                            </span>
                          </mat-hint>
                        </mat-form-field>
                      </div>

                      <div class="col-md-3">
                        <mat-form-field>
                          <mat-label>{{
                            ("shifts.1" | i18n) || "Tag"
                          }}</mat-label>
                          <input
                            matInput
                            type="number"
                            [ngModel]="department.appliedValues[shiftEnum.DAY]"
                            (ngModelChange)="
                              updateDepartmentPreventDirectAcceptWithinSecondsPerShift(
                                department,
                                customer._id,
                                shiftEnum.DAY,
                                $event
                              )
                            "
                            name="preventDirectAcceptWithinSecondsPerShiftDay"
                            data-cy="prevent-direct-accept-within-seconds-per-shift-day-shift" />
                          <button
                            *ngIf="
                              department.appliedValues[shiftEnum.DAY] !==
                              department.defaultValues[shiftEnum.DAY]
                            "
                            mat-icon-button
                            matSuffix
                            type="button"
                            (click)="
                              resetDepartmentPreventDirectAcceptValue(
                                department,
                                customer._id,
                                shiftEnum.DAY
                              )
                            "
                            data-cy="reset-prevent-direct-accept-day-shift">
                            <mat-icon svgIcon="close"></mat-icon>
                          </button>
                          <mat-hint
                            *ngIf="
                              department.appliedValues[shiftEnum.DAY] !==
                              department.defaultValues[shiftEnum.DAY]
                            ">
                            {{ "default" | i18n }}:
                            <span style="text-decoration: line-through">
                              {{ department.defaultValues[shiftEnum.DAY] }}h
                            </span>
                          </mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-md-3">
                        <mat-form-field>
                          <mat-label>{{
                            ("shifts.2" | i18n) || "Spät"
                          }}</mat-label>
                          <input
                            matInput
                            type="number"
                            [ngModel]="department.appliedValues[shiftEnum.LATE]"
                            (ngModelChange)="
                              updateDepartmentPreventDirectAcceptWithinSecondsPerShift(
                                department,
                                customer._id,
                                shiftEnum.LATE,
                                $event
                              )
                            "
                            name="preventDirectAcceptWithinSecondsPerShiftLate"
                            data-cy="prevent-direct-accept-within-seconds-per-shift-late-shift" />
                          <button
                            *ngIf="
                              department.appliedValues[shiftEnum.LATE] !==
                              department.defaultValues[shiftEnum.LATE]
                            "
                            mat-icon-button
                            matSuffix
                            type="button"
                            (click)="
                              resetDepartmentPreventDirectAcceptValue(
                                department,
                                customer._id,
                                shiftEnum.LATE
                              )
                            "
                            data-cy="reset-prevent-direct-accept-late-shift">
                            <mat-icon svgIcon="close"></mat-icon>
                          </button>
                          <mat-hint
                            *ngIf="
                              department.appliedValues[shiftEnum.LATE] !==
                              department.defaultValues[shiftEnum.LATE]
                            ">
                            {{ "default" | i18n }}:
                            <span style="text-decoration: line-through">
                              {{ department.defaultValues[shiftEnum.LATE] }}h
                            </span>
                          </mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-md-3">
                        <mat-form-field>
                          <mat-label>{{
                            ("shifts.3" | i18n) || "Nacht"
                          }}</mat-label>
                          <input
                            matInput
                            type="number"
                            [ngModel]="
                              department.appliedValues[shiftEnum.NIGHT]
                            "
                            (ngModelChange)="
                              updateDepartmentPreventDirectAcceptWithinSecondsPerShift(
                                department,
                                customer._id,
                                shiftEnum.NIGHT,
                                $event
                              )
                            "
                            name="preventDirectAcceptWithinSecondsPerShiftNight"
                            data-cy="prevent-direct-accept-within-seconds-per-shift-night-shift" />
                          <button
                            *ngIf="
                              department.appliedValues[shiftEnum.NIGHT] !==
                              department.defaultValues[shiftEnum.NIGHT]
                            "
                            mat-icon-button
                            matSuffix
                            type="button"
                            (click)="
                              resetDepartmentPreventDirectAcceptValue(
                                department,
                                customer._id,
                                shiftEnum.NIGHT
                              )
                            "
                            data-cy="reset-prevent-direct-accept-night-shift">
                            <mat-icon svgIcon="close"></mat-icon>
                          </button>
                          <mat-hint
                            *ngIf="
                              department.appliedValues[shiftEnum.NIGHT] !==
                              department.defaultValues[shiftEnum.NIGHT]
                            ">
                            {{ "default" | i18n }}:
                            <span style="text-decoration: line-through">
                              {{ department.defaultValues[shiftEnum.NIGHT] }}h
                            </span>
                          </mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="customer?.timeTrackingEnabled">
                      <h3>
                        {{
                          ("timeTrackingSettings" | i18n) ||
                            "Zeiterfassung Einstellungen"
                        }}
                      </h3>
                      <h4>
                        {{
                          ("timeTrackingDefaultPauseByDepartment" | i18n) ||
                            "Standard Pause pro Schicht"
                        }}
                      </h4>
                      <div class="shift-settings-container row">
                        <div class="col-md-3">
                          <mat-form-field>
                            <mat-label>{{
                              ("shifts.0" | i18n) || "Früh"
                            }}</mat-label>
                            <input
                              matInput
                              type="number"
                              [ngModel]="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.EARLY
                                ]
                              "
                              (ngModelChange)="
                                updateDepartmentTimeTrackingPause(
                                  department,
                                  customer._id,
                                  shiftEnum.EARLY,
                                  $event
                                )
                              "
                              name="preventDirectAcceptWithinSecondsPerShiftEarly"
                              data-cy="prevent-direct-accept-within-seconds-per-shift-early-shift" />
                            <button
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.EARLY
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.EARLY
                                ]
                              "
                              mat-icon-button
                              matSuffix
                              type="button"
                              (click)="
                                resetDepartmentTimeTrackingPauseValue(
                                  department,
                                  customer._id,
                                  shiftEnum.EARLY
                                )
                              "
                              data-cy="reset-prevent-direct-accept-early-shift">
                              <mat-icon svgIcon="close"></mat-icon>
                            </button>
                            <mat-hint
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.EARLY
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.EARLY
                                ]
                              ">
                              {{ "default" | i18n }}:
                              <span style="text-decoration: line-through">
                                {{
                                  department.timeTrackingDefaultPause[
                                    shiftEnum.EARLY
                                  ]
                                }}h
                              </span>
                            </mat-hint>
                          </mat-form-field>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field>
                            <mat-label>{{
                              ("shifts.1" | i18n) || "Tag"
                            }}</mat-label>
                            <input
                              matInput
                              type="number"
                              [ngModel]="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.DAY
                                ]
                              "
                              (ngModelChange)="
                                updateDepartmentTimeTrackingPause(
                                  department,
                                  customer._id,
                                  shiftEnum.DAY,
                                  $event
                                )
                              "
                              name="preventDirectAcceptWithinSecondsPerShiftDay"
                              data-cy="prevent-direct-accept-within-seconds-per-shift-day-shift" />
                            <button
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.DAY
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.DAY
                                ]
                              "
                              mat-icon-button
                              matSuffix
                              type="button"
                              (click)="
                                resetDepartmentTimeTrackingPauseValue(
                                  department,
                                  customer._id,
                                  shiftEnum.DAY
                                )
                              "
                              data-cy="reset-prevent-direct-accept-day-shift">
                              <mat-icon svgIcon="close"></mat-icon>
                            </button>
                            <mat-hint
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.DAY
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.DAY
                                ]
                              ">
                              {{ "default" | i18n }}:
                              <span style="text-decoration: line-through">
                                {{
                                  department.timeTrackingDefaultPause[
                                    shiftEnum.DAY
                                  ]
                                }}h
                              </span>
                            </mat-hint>
                          </mat-form-field>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field>
                            <mat-label>{{
                              ("shifts.2" | i18n) || "Spät"
                            }}</mat-label>
                            <input
                              matInput
                              type="number"
                              [ngModel]="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.LATE
                                ]
                              "
                              (ngModelChange)="
                                updateDepartmentTimeTrackingPause(
                                  department,
                                  customer._id,
                                  shiftEnum.LATE,
                                  $event
                                )
                              "
                              name="preventDirectAcceptWithinSecondsPerShiftLate"
                              data-cy="prevent-direct-accept-within-seconds-per-shift-late-shift" />
                            <button
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.LATE
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.LATE
                                ]
                              "
                              mat-icon-button
                              matSuffix
                              type="button"
                              (click)="
                                resetDepartmentTimeTrackingPauseValue(
                                  department,
                                  customer._id,
                                  shiftEnum.LATE
                                )
                              "
                              data-cy="reset-prevent-direct-accept-late-shift">
                              <mat-icon svgIcon="close"></mat-icon>
                            </button>
                            <mat-hint
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.LATE
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.LATE
                                ]
                              ">
                              {{ "default" | i18n }}:
                              <span style="text-decoration: line-through">
                                {{
                                  department.timeTrackingDefaultPause[
                                    shiftEnum.LATE
                                  ]
                                }}h
                              </span>
                            </mat-hint>
                          </mat-form-field>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field>
                            <mat-label>{{
                              ("shifts.3" | i18n) || "Nacht"
                            }}</mat-label>
                            <input
                              matInput
                              type="number"
                              [ngModel]="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.NIGHT
                                ]
                              "
                              (ngModelChange)="
                                updateDepartmentTimeTrackingPause(
                                  department,
                                  customer._id,
                                  shiftEnum.NIGHT,
                                  $event
                                )
                              "
                              name="preventDirectAcceptWithinSecondsPerShiftNight"
                              data-cy="prevent-direct-accept-within-seconds-per-shift-night-shift" />
                            <button
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.NIGHT
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.NIGHT
                                ]
                              "
                              mat-icon-button
                              matSuffix
                              type="button"
                              (click)="
                                resetDepartmentTimeTrackingPauseValue(
                                  department,
                                  customer._id,
                                  shiftEnum.NIGHT
                                )
                              "
                              data-cy="reset-prevent-direct-accept-night-shift">
                              <mat-icon svgIcon="close"></mat-icon>
                            </button>
                            <mat-hint
                              *ngIf="
                                department.timeTrackingAppliedPause[
                                  shiftEnum.NIGHT
                                ] !==
                                department.timeTrackingDefaultPause[
                                  shiftEnum.NIGHT
                                ]
                              ">
                              {{ "default" | i18n }}:
                              <span style="text-decoration: line-through">
                                {{
                                  department.timeTrackingDefaultPause[
                                    shiftEnum.NIGHT
                                  ]
                                }}h
                              </span>
                            </mat-hint>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </app-accordion-content>
            </app-accordion>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
    <ng-template #loading>
      <div class="loading-container">
        <mat-spinner
          diameter="24"
          data-cy="organisations-loading-spinner"></mat-spinner>
      </div>
    </ng-template>
  </div>
  <ng-template #disableTimeTrackingConfirm>
    <div *ngIf="currentTimeTrackingEnabledState">
      <h1 mat-dialog-title>
        {{ ("disableTimeTracking" | i18n) || "Zeiterfassung deaktivieren" }}
      </h1>
      <div
        mat-dialog-content
        class="dialog-text">
        {{
          ("disableTimeTrackingDescription" | i18n) ||
            "Wenn Sie dieZeiterfassung deaktivieren, können Sie keine Stunden erfassen und die noch ausstehenden Stundenerfassungen werden gelöscht."
        }}
      </div>
    </div>
    <div *ngIf="!currentTimeTrackingEnabledState">
      <h1 mat-dialog-title>
        {{ ("enableTimeTracking" | i18n) || "Zeiterfassung aktivieren" }}
      </h1>
      <div
        mat-dialog-content
        class="dialog-text">
        {{
          ("enableTimeTrackingDescription" | i18n) ||
            "Wenn Sie die Zeiterfassung aktivieren, wird dies für alle zukünftig erstellten Dienste gelten, jedoch nicht für bereits erfasste Dienste."
        }}
      </div>
    </div>
    <mat-dialog-actions>
      <button
        mat-button
        mat-dialog-close>
        {{ ("cancel" | i18n) || "cancel" | titlecase }}
      </button>
      <button
        mat-button
        [mat-dialog-close]="true">
        {{ ("confirm" | i18n) || "confirm" | titlecase }}
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
